import CreateApiService from "../../../../utils/Config/LaravelService";

const createBillSplitsService = () => {
  return {
    async getBillSplitOrdersList(filters) {
      const params = new URLSearchParams();
      if (filters.splitMethod) params.append('type', filters.splitMethod);
      if (filters.server) params.append('createdBy', filters.server);
      if (filters.table) params.append('table', filters.table);
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);
      if (filters.page) params.append('page', filters.page);
      if (filters.pageSize) params.append('pageSize', filters.pageSize);
      if (filters.section) params.append('section', filters.section);

      const queryString = params.toString();
      const url = `/web/v1/orders/splits${queryString ? `?${queryString}` : ''}`;
      return CreateApiService.get(url);   
    },
    async getOrgEmployees() {
      return CreateApiService.get(`/web/v1/employee-organization`);
    },
    async getOrganizationTableList() {
      return CreateApiService.get(`/web/v1/table-list`);
    },
    async getSectionList() {
      return CreateApiService.get(`/web/v1/org-sections`);
    },
    async getBillSplitDownloadUrl(filters) {
      const params = new URLSearchParams();
      if (filters.splitMethod) params.append('type', filters.splitMethod);
      if (filters.server) params.append('createdBy', filters.server);
      if (filters.table) params.append('table', filters.table);
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);
      if (filters.page) params.append('page', filters.page);
      if (filters.pageSize) params.append('pageSize', filters.pageSize);
      if (filters.section) params.append('section', filters.section);

      const queryString = params.toString();
      const url = `/web/v1/orders/splits/export${queryString ? `?${queryString}` : ''}`;
      return CreateApiService.get(url);
    }

    
  };
};

export const billSplitsService = createBillSplitsService();